import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

/**
 * True while a navigation that reloads server data is in progress.
 * Shallow URL updates (filters kept in the address bar) are ignored.
 */
export const usePageLoading = (): boolean => {
    const router = useRouter()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const start = (_url: string, { shallow }: { shallow: boolean }) => {
            if (!shallow) setLoading(true)
        }

        const done = () => setLoading(false)

        router.events.on('routeChangeStart', start)
        router.events.on('routeChangeComplete', done)
        router.events.on('routeChangeError', done)

        return () => {
            router.events.off('routeChangeStart', start)
            router.events.off('routeChangeComplete', done)
            router.events.off('routeChangeError', done)
        }
    }, [router.events])

    return loading
}
